import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { isValidResponse } from './callbackActions';
export var emailUsActionsEnum;
(function (emailUsActionsEnum) {
    emailUsActionsEnum["RESET_DATA_MODAL"] = "RESET_DATA_MODAL";
    emailUsActionsEnum["EMAIL_US_REQUEST"] = "EMAIL_US_REQUEST";
    emailUsActionsEnum["EMAIL_US_SUCCESS"] = "EMAIL_US_SUCCESS";
    emailUsActionsEnum["EMAIL_US_ERROR"] = "EMAIL_US_ERROR";
})(emailUsActionsEnum || (emailUsActionsEnum = {}));
export function submitEmailUsData(payload) {
    return (dispatch) => {
        dispatch({
            type: emailUsActionsEnum.EMAIL_US_REQUEST
        });
        let headers = Object.assign({}, baseAjaxConfig.headers);
        delete headers['Content-Type'];
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/self-serve/helpcenter/v2/email',
            multipart: true,
            headers,
            action: emailUsActionsEnum.EMAIL_US_REQUEST
        }), payload).then(data => {
            if (isValidResponse(data['RESPONSE'])) {
                dispatch({
                    type: emailUsActionsEnum.EMAIL_US_SUCCESS,
                    data: data['RESPONSE']
                });
            }
            else {
                dispatch({
                    type: emailUsActionsEnum.EMAIL_US_ERROR,
                    error: {}
                });
            }
        }, error => {
            dispatch({
                type: emailUsActionsEnum.EMAIL_US_ERROR,
                error
            });
        });
    };
}
